// Renders the auth pages' customer-service block from the shared auth
// documents' opaque `cs_info_json` seam (a serialized CustomerServiceInfoBlock).
// The shared password-reset @template classes carry only this JSON field (no
// typed `cs_info`), so every stearns auth page feeds the block through here for
// one uniform path -- parsed into the existing CustomerServiceInfoBlock island
// so its ChatLink stays an interactive hydration island, exactly as the legacy
// account pages included it.
//
// Returns null on an empty or unparseable payload so a parse failure degrades
// only this block, never the whole document.
import React from "react";

import { templates } from "@reactivated";

import { CustomerServiceInfoBlock } from "../CustomerServiceInfoBlock";

export const AuthCustomerServiceBlock = ({
    payload,
}: {
    payload: string;
}): React.JSX.Element | null => {
    if (!payload) {
        return null;
    }
    let info: NonNullable<templates.LoginDocumentTemplate["cs_info"]> | null;
    try {
        info = JSON.parse(payload) as NonNullable<
            templates.LoginDocumentTemplate["cs_info"]
        > | null;
    } catch {
        return null;
    }
    // A "null" payload parses to `null` without throwing; guard so it degrades
    // to null here rather than crashing on `info.heading` inside the block.
    if (!info) {
        return null;
    }
    return <CustomerServiceInfoBlock info={info} />;
};
